var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNonAssociated(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    transform: "translate(0 0)",
    fill: "#73a91b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-7902 22205)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 56,
    r: 56,
    transform: "translate(7902 -22205)",
    fill: "#eaf2dd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56,1a54.739,54.739,0,0,0-30.75,9.393,55.163,55.163,0,0,0-19.928,24.2A54.926,54.926,0,0,0,10.393,86.75a55.163,55.163,0,0,0,24.2,19.928,54.926,54.926,0,0,0,52.158-5.071,55.163,55.163,0,0,0,19.928-24.2,54.926,54.926,0,0,0-5.071-52.158,55.163,55.163,0,0,0-24.2-19.928A54.655,54.655,0,0,0,56,1m0-1A56,56,0,1,1,0,56,56,56,0,0,1,56,0Z",
    transform: "translate(7902 -22205)",
    fill: "#eaf2dd"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1 1.999)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(7922.31 -22184.734)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.31 -0.265)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.43,21.751A35.623,35.623,0,0,0,2.8,49.477q.633,1.5,1.394,2.917a17.37,17.37,0,0,1,.728-2.136,34.009,34.009,0,1,1,64.7-14.644,33.809,33.809,0,0,1-3.317,14.644,17.383,17.383,0,0,1,.728,2.136q.759-1.422,1.394-2.917a35.728,35.728,0,0,0,0-27.726",
    transform: "translate(0.272 0.25)",
    fill: "#73a91b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.512,235.241a5.739,5.739,0,1,0-5.739,5.739,5.739,5.739,0,0,0,5.739-5.739",
    transform: "translate(-314.511 -198.203)",
    fill: "#73a91b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.976,303.921a9.588,9.588,0,0,0-7.922,3.748c1.96,3.47,2.336,12.127,2.336,12.127s-1.171-8.657-3.015-12.127c-1.806-3.4-5.041-6.759-10.774-6.759s-8.968,3.362-10.774,6.759c-1.844,3.47-3.015,12.127-3.015,12.127s.376-8.657,2.336-12.127a9.588,9.588,0,0,0-7.922-3.748c-6.752,0-9.33,5.361-10.266,8.555a14.63,14.63,0,0,0-.5,2.32l0,0a35.637,35.637,0,0,0,60.277,0l0,0a14.617,14.617,0,0,0-.5-2.32c-.937-3.194-3.515-8.555-10.266-8.555",
    transform: "translate(-34.715 -259.95)",
    fill: "#73a91b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.1,235.241a5.739,5.739,0,1,0-5.739,5.739,5.739,5.739,0,0,0,5.739-5.739",
    transform: "translate(-66.844 -198.203)",
    fill: "#73a91b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.265,195.645h0a7.35,7.35,0,1,0-7.351-7.351A7.35,7.35,0,0,0,216.265,195.645Z",
    transform: "translate(-180.378 -156.214)",
    fill: "#73a91b"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3 4)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    transform: "translate(7968 -22192)",
    fill: "#eaf2dd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5,1A14.5,14.5,0,0,0,5.247,25.753,14.5,14.5,0,0,0,25.753,5.247,14.405,14.405,0,0,0,15.5,1m0-1A15.5,15.5,0,1,1,0,15.5,15.5,15.5,0,0,1,15.5,0Z",
    transform: "translate(7968 -22192)",
    fill: "#d5000e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.824,0H15.2L10.1-7.656,15-15.444H10.736L8.008-10.78l-3.1-4.664H.528l5.06,7.59L.638,0H4.906L7.678-4.73Z",
    transform: "translate(7975.472 -22168.557)",
    fill: "#d5000e"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNonAssociated);
export default __webpack_public_path__ + "static/media/non-associated.fa4755df22d81628cd7d79a3d046a077.svg";
export { ForwardRef as ReactComponent };